import React from "react";
import Lottie from "lottie-react";
import Animation_success from "./animation_success.json";
import {Autocomplete, Box, Button, Divider, Grid, TextField} from '@mui/material';
import { display, styled } from '@mui/system';
import EastIcon from '@mui/icons-material/East';
import '../servicesOperation.css'
import Modal_Filtro_Structure from "./Modal_Filtro_structure";


export const Modal_Filtro = () => {
    
    const top100Films = [
        { label: 'The Shawshank Redemption', year: 1994 },
        { label: 'The Godfather', year: 1972 },
        { label: 'The Godfather: Part II', year: 1974 },
        { label: 'The Dark Knight', year: 2008 },
        { label: '12 Angry Men', year: 1957 },
        { label: "Schindler's List", year: 1993 },
        { label: 'Pulp Fiction', year: 1994 },
        {
          label: 'The Lord of the Rings: The Return of the King',
          year: 2003,
        },
        { label: 'The Good, the Bad and the Ugly', year: 1966 },
        { label: 'Fight Club', year: 1999 },
        {
          label: 'The Lord of the Rings: The Fellowship of the Ring',
          year: 2001,
        },
        {
          label: 'Star Wars: Episode V - The Empire Strikes Back',
          year: 1980,
        },
        { label: 'Forrest Gump', year: 1994 },
        { label: 'Inception', year: 2010 },
        {
          label: 'The Lord of the Rings: The Two Towers',
          year: 2002,
        },
        { label: "One Flew Over the Cuckoo's Nest", year: 1975 },
        { label: 'Goodfellas', year: 1990 },
        { label: 'The Matrix', year: 1999 },
        { label: 'Seven Samurai', year: 1954 },
        {
          label: 'Star Wars: Episode IV - A New Hope',
          year: 1977,
        }
    ]
    const Label = styled('label')({
        display: 'block',
        fontWeight: 'bold',
        paddingLeft: '18px'
      });
    return <>
    
        <Box sx={{ flexGrow: 1, marginTop: '8px'}}>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                <Grid item  xs={12} sm={12} md={12}  key='1'>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={top100Films}
                        sx={{ margin: '16px'}}
                        renderInput={(params) => <TextField {...params} label="Movie" />}
                        />
                </Grid>
                <Modal_Filtro_Structure key='1' labelTitle='Days Remaining' label_input_one='Min Days' id_one='id_day_remaining_one' label_input_two='Max Days' id_two='id_day_remaining_two' />
                <Modal_Filtro_Structure key='2' labelTitle='Date to Reorder' label_input_one='Date' id_one='id_date_reorder_one' label_input_two='Date' id_two='id_date_reorder_two' />
                <Modal_Filtro_Structure key='3' labelTitle='Reorder Quantity' label_input_one='Min Qty' id_one='id_quantity_one' label_input_two='Qty' id_two='id_quantity_two' />
                <Modal_Filtro_Structure key='4' labelTitle='Inventory Level' label_input_one='Min Inventory' id_one='id_inventory_one' label_input_two='Max Inventory' id_two='id_inventory_two' />
                <Modal_Filtro_Structure key='5' labelTitle='Inbound Level' label_input_one='Min Level' id_one='id_level_one' label_input_two='Max Level' id_two='id_level_two' />
                <Modal_Filtro_Structure key='6' labelTitle='Average Daily Sales' label_input_one='Min Sales' id_one='id_daily_sales_one' label_input_two='Max Sales' id_two='id_daily_sales_two' />

            </Grid>
            <Divider />
                <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" disabled sx={{marginRight: '16px'}}>Cancel</Button>
                    <Button variant="contained">Apply</Button>
                </Box>
        </Box>
        </>
};

export default Modal_Filtro;